export default function NotFound() {
    return <h2>Not found</h2>
}